import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-version",
  templateUrl: "./version.page.html",
  styleUrls: ["./version.page.scss"],
})
export class VersionPage implements OnInit {
  fileContent: string = ""; // To store the content of the .txt file

  constructor(
    public modalController: ModalController,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.loadFile();
  }

  loadFile() {
    this.http
      .get("assets/CustomContent/SystemDocs/changelog.txt", {
        responseType: "text",
      })
      .subscribe(
        (data) => {
          this.fileContent = data;
        },
        (error) => {
          console.error("Could not load the file", error);
        }
      );
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
